var exports = {
  "rf": "ShopierAddTimeModal.module__body___LXFFRz",
  "fF": "ShopierAddTimeModal.module__options___LXFFRz",
  "uK": "ShopierAddTimeModal.module__option___LXFFRz",
  "h4": "ShopierAddTimeModal.module__optionSelected___LXFFRz",
  "H9": "ShopierAddTimeModal.module__optionIcon___LXFFRz",
  "re": "ShopierAddTimeModal.module__optionText___LXFFRz",
  "Ee": "ShopierAddTimeModal.module__optionTitle___LXFFRz",
  "Zp": "ShopierAddTimeModal.module__optionBadge___LXFFRz",
  "$f": "ShopierAddTimeModal.module__optionPrice___LXFFRz",
  "Ow": "ShopierAddTimeModal.module__radio___LXFFRz",
};

module.exports = exports;
